export function setPayments(state, payload) {
  state.payments = payload;
}
